(function($) {
	function setInstagramSquares() {
		if($('.instagram-feed').length > 0) {
			_width = $('.instagram-feed .slider-item').outerWidth();
			$('.instagram-feed').height(_width);
			$('.instagram-feed .slider-item').height(_width);
		}
	}

	function setSquareFeatures() {
		featureWidth = $('.home-features .feature-box').width();
		salonWidth = $('.salon-box').width();
		relatedWidth = $('.related-box').width();
		$('.home-features .feature-box').height(featureWidth);
		$('.salon-box').height(salonWidth);
		$('.related-box').height(relatedWidth);

		var breakpointMin = 768;
		var breakpointMax = 991;
		var currentWidth = parseInt( $('#current-media').css('max-width'), 10 );
		if ( currentWidth >= breakpointMin && currentWidth <= breakpointMax ) {
			$('.mapp-canvas').height($('.salon-box').height());
		} else {
			$('.mapp-canvas').height(salonWidth);
		}
	}

	function setHeroBanner() {
		$('.hero-banner .slider-item').height($(window).height() - $('.banner').height());
		// Fade out the overlay
		$('#hero-banner-overlay').fadeOut(1000);
	}

	function setNews() {
		newsWidth = $('.news-box').width();
		$('.news-box').height(newsWidth);
	}

	function handleSubMenuToggle( e ) {
		e.preventDefault();

		var $container = $( e.target );
		var $submenu;
		var $toggle;

		if ( $container.hasClass('nav-toggle') ) {
			$toggle = $container;
			$submenu = $container.parent().parent().find( '.sub-menu' );
		} else {
			$toggle = $container.find('.nav-toggle');
			$submenu = $container.parent().find( '.sub-menu' );
		}

		if ( $submenu.length ) {
			if ( $submenu.is(':visible') ) {
				$toggle.removeClass('open');
			} else {
				$toggle.addClass('open');
			}

			$submenu.stop().slideToggle(400, function() {});
		}
	}

	function toggleNav() {
		if ( $('.burger-btn').hasClass('opened') ) {
			$('.burger-btn').removeClass('opened');
			$('.banner .navbar-nav').removeClass('opened');
			$('.responsive-menu').slideUp();
			Cookies.remove( 'menu_open' );
		} else {
			$('.burger-btn').addClass('opened');
			$('.banner .navbar-nav').addClass('opened');
			$('.responsive-menu').slideDown();
			Cookies.set( 'menu_open', true );
		}
	}

	function hideMobileNav() {
		var breakpoint = 1199;
		var currentWidth = parseInt( $('#current-media').css('max-width'), 10 );
		if ( currentWidth <= breakpoint ) {
			$('.burger-btn').removeClass('opened');
			$('.banner .navbar-nav').removeClass('opened');
			$('.responsive-menu').slideUp();
			Cookies.remove( 'menu_open' );
		}
	}

	var Sage = {
		// All pages
		'common': {
			init: function() {
				// JavaScript to be fired on all pages
			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
				setSquareFeatures();
				setNews();

				$("#hero-banner").owlCarousel({
					loop: true,
					margin: 0,
					nav: true,
					items: 1,
					dots: true,
					autoplay: true,
					autoplayTimeout: 8500,
					autoplaySpeed: 500,
					dotsEach: false,
					dotsContainer: '.hero-dots',
					navContainer: '.hero-navs',
					navText: [' ',' ']
				});

				setHeroBanner();

				// Always hide the mobile nav on a page refresh
				hideMobileNav();

				$('.burger-btn').on('click', toggleNav);

				$('#menu-main-menu-1 .sub-menu, #menu-explore-menu .sub-menu').hide();
				$('#menu-main-menu-1 .menu-item-has-children > a, #menu-explore-menu .menu-item-has-children > a').each(function() {
					var $toggle = $('<div class="nav-toggle"></div>');
					$(this).append( $toggle );

					var elements = [ $toggle ];

					if ( $(this).attr('href') === '#' ) {
						// elements.push( $(this) );
						elements = [ $(this) ];
					}

					for (var i = 0; i < elements.length; i++) {
						elements[i].on('click', handleSubMenuToggle );
					}
				});

				$('.book-now-btn').click(function(e) {
					e.preventDefault();
					$('body').addClass('overlayOpened');
					$('.book-overlay').fadeIn();
					return false;
				});

				$('.overlay-close').click(function() {
					$('.book-overlay').fadeOut();
					$('body').removeClass('overlayOpened');
				});

				$('.instagram-feed').on('initialized.owl.carousel',function() {
					setInstagramSquares();
					$('.owl-next').append('<div class="arrow-right"></div>');
					$('.owl-prev').append('<div class="arrow-left"></div>');
				}).owlCarousel({
					loop: false,
					margin: 0,
					nav: true,
					items: 4,
					dots: false,
					autoplay : false,
					autoplayTimeout : 8500,
					autoplaySpeed:500,
					dotsEach : false,
					navText: [' ',' '],
					autowidth:true,
					responsive: {
						0: {
							items : 1
						},
						768: {
							items : 4
						}
					}
				});

				$('.page-template-template-salon .wpcf7 input[name="subject"]').val($('#subject-title').val());

				$('.wpcf7 textarea').focus(function() {
					$(this).animate({height:'135px'},400);
				});

				$('.wpcf7 textarea').focusout(function() {
					$(this).animate({height:'35px'},400);
				});


				$('table.responsiveTable').each(function(){
					var table = $(this);
					table.addClass('js');
					table.find('th').each(function() {
						var columnIndex = $(this).index();
						var columnTitle = $(this).text();
						table.find('tr').each(function() {
							$(this).find('td').eq(columnIndex).attr('data-title', columnTitle);
						});
					});
				});	

				$('.share-popover .icon.share-close').click(function() {
					$('#share-btn .share-popover').hide();
					return false;
				});

				$('#share-btn').click(function() {
					$('#share-popover').show();
				});

				var clicked = 0;

				$('#viewmore').on('click', function() {
					if (clicked === 0) {
						_offset = (page * ppp); 
					} else {
						_offset = (page * ppp) + 1;
					}
					$('#viewmore').attr('disabled',true);
					$.post(ajaxUrl, {
						action: "load_more_news",
						offset: _offset,
						posts_per_page : ppp
					}).success(function(news) {
						if (news != 0) {
							page++;
							clicked++;
							$('#news-container').append(news);
							setNews();
						}
						$('#viewmore').attr('disabled', false);
					});
				});
			}
		}
	};

	var UTIL = {
		fire: function(func, funcname, args) {
		  var fire;
		  var namespace = Sage;
		  funcname = (funcname === undefined) ? 'init' : funcname;
		  fire = func !== '';
		  fire = fire && namespace[func];
		  fire = fire && typeof namespace[func][funcname] === 'function';
	
		  if (fire) {
			namespace[func][funcname](args);
		  }
		},
		loadEvents: function() {
		  // Fire common init JS
		  UTIL.fire('common');
	
		  // Fire page-specific init JS, and then finalize JS
		  $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
			UTIL.fire(classnm);
			UTIL.fire(classnm, 'finalize');
		  });

		  // Fire common finalize JS
		  UTIL.fire('common', 'finalize');
		}
	};

	// Load Events
	$(document).ready(UTIL.loadEvents);

	$(window).load(function() {});

	$(window).resize(function() {
		setHeroBanner();
		setSquareFeatures();
		setNews();
		setInstagramSquares();
		hideMobileNav();
	});
})(jQuery); // Fully reference jQuery after this point.
